export const USER_KEYS = {
  all: ["user"] as const,
  contact: (userId: number) => [...USER_KEYS.all, "contact", userId] as const,
};
